import React from 'react'
import { Link } from '@lana-ui/common'

const BrandItem = ({ icon, name, ...props }) => {
  return (
    <Link className='flex gap-8 text-neutral-light-800' {...props}>
      <i className='w-20 h-20'>{icon}</i>
      <span className='--arial text-14 uppercase'>{name}</span>
    </Link>
  )
}

export default BrandItem
